import {
    Component, Input, Output, EventEmitter,
    OnChanges, SimpleChanges, AfterViewInit, OnInit, Injector
} from '@angular/core';
import { TpaService } from '../../../tpa/shared/tpa.service';
import { ServiceLocator } from '../../../shared/serviceLocator.injector';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'pager',
    templateUrl: './pager.component.html',
    styleUrls: ['./pager.component.scss'],
    standalone: false
})
export class PagerComponent implements OnChanges, OnInit {

    @Input() public source: any;
    @Input() public perPage: number;
    @Output() public changePageEvent = new EventEmitter<any>();
    @Output() public paginateEvent = new EventEmitter<any>();
    @Output() public initPagesEvent = new EventEmitter<any>();
    public data: any[];
    public control: FormControl;
    public tpaService: TpaService;
    protected dataChangedSub: Subscription;
    protected pages: any[];
    protected page: number;
    protected count: number = 0;
    private subscription: Subscription;

    constructor(private injector: Injector) {
        this.tpaService = injector.get(TpaService);
        this.control = new FormControl(1);
    }

    public ngOnInit() {
        this.page = 1;
        this.control.setValue(1);
        this.tpaService.notifyPageChange.subscribe((page) => {
            this.page = page;
            this.count = this.source.data.length;
            if (this.isPageOutOfBounce()) {
                this.source.setPage(--this.page);
            }
            this.initPages();
            this.control.setValue(this.page);
            this.paginateEvent.emit({
                data: this.data,
                page: this.page
            });
        });
        this.tpaService.initPages.subscribe((page) => {
            this.page = page;
            this.count = this.source.data.length;
            if (this.isPageOutOfBounce()) {
                this.source.setPage(--this.page);
            }
            this.initPages();
            this.initPagesEvent.emit({
                data: this.data,
                page: this.page
            });
        });
    }
    public ngOnChanges(changes: SimpleChanges) {
        if (changes.source) {
            this.perPage = this.perPage;
            this.count = this.source.data.length;
            this.control.setValue(1);
            this.page = 1;
            if (this.isPageOutOfBounce()) {
                this.source.setPage(--this.page);
            }
            this.initPages();
        }
    }

    public changePage(event: Event | number): boolean {
        let page: number;
        if (typeof event === 'number') {
            page = event;
        } else {
            const target = event.target as HTMLSelectElement;
            page = Number(target.value);
        }
        // logic for promise call to be included when edit is implemented
        // this.page = page;
        // this.data = this.paginate(this.source.data, page, this.perPage);
        // this.control.setValue(page);
        this.changePageEvent.emit({
            page,
            data: this.data
        });
        return false;
    }

    public getPage(): number {
        return this.page;
    }

    public getPages(): any[] {
        return this.pages;
    }

    public getPageCount(): number {
        if (this.pages) {
            return this.pages.length;
        }
        return 0;
    }

    public getLast(): number {
        return Math.ceil(this.count / this.perPage);
    }

    public getNextPage(): number {
        let page = this.getPage();
        page++;
        return page;
    }

    public getPreviousPage(): number {
        return this.getPage() - 1;
    }

    public isPageOutOfBounce(): boolean {
        return (this.page * this.perPage) >= (this.count + this.perPage) && this.page > 1;
    }

    public initPages() {
        const pagesCount = this.getLast();
        let showPagesCount = 400;
        showPagesCount = pagesCount < showPagesCount ? pagesCount : showPagesCount;
        this.pages = [];
        let middleOne = Math.ceil(showPagesCount / 2);
        middleOne = this.page >= middleOne ? this.page : middleOne;

        let lastOne = middleOne + Math.floor(showPagesCount / 2);
        lastOne = lastOne >= pagesCount ? pagesCount : lastOne;

        const firstOne = lastOne - showPagesCount + 1;

        for (let i = firstOne; i <= lastOne; i++) {
            this.pages.push(i);
        }
    }

    public paginate(data: any[], page: number, perPage: number): any[] {
        return data.slice(perPage * (page - 1), perPage * page);
    }
}
